// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-workorder-report-search-group-section {
    width: 100%;
}

.view-workorder-report-header-search-group-row-section {
    grid-template-columns: 3.2fr 0.8fr !important;
}

.view-workorder-report-serch-item-section .react-date-picker__calendar{
    z-index: 4 !important;
}
.view-workorder-report-search-group-section .view-workorder-report-serch-item-section:first-child,
.view-workorder-report-search-group-section .view-workorder-report-serch-item-section:nth-child(2) {
    display: grid;
    column-gap: 10px;
    grid-template-columns: 1fr 1fr;
    row-gap: 10px;
}

#viewWorkOrderReportAdvanceSearch .modal-body {
    overflow-y: initial;
}

#viewWorkOrderReportAdvanceSearch .modal-dialog .modal-body .wrapper-modal-body .mobal-body-section-group:nth-child(3) {
    grid-template-columns: 1fr;
}

#viewWorkOrderReportAdvanceSearch .wrapper-modal-body .react-date-picker__calendar.react-date-picker__calendar--open {
    inset: 100% 0px auto auto !important;
}



/* ------- View Report Table ------- */
.wraper-body-report-table-section {
    width: 100%;
    height: 50vh;
    overflow: scroll;
    /* border: 1px solid; */
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    display: block;
}

.wraper-body-report-table-section table thead {
    border-bottom: 1px solid;
    position: sticky;
    top: 0;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    z-index: 2;
}

.wraper-body-report-table-section table tr th,
.wraper-body-report-table-section table tr td {
    min-width: 190px;
    padding: 6px;
}

.wraper-body-report-table-section table thead tr th:first-child,
.wraper-body-report-table-section table tbody tr td:first-child {
    min-width: 90px;
    position: sticky;
    left: 0;
    z-index: 1;
}

.wraper-body-report-table-section table thead tr th:first-child::after,
.wraper-body-report-table-section table tbody tr td:first-child::after{
    content: "";
    height: 100%;
    width: 100%;
    position: absolute;
    border-right: 1px solid F3F3F3;
    box-shadow: 4px 0 5px -2px #00000029;
    left: 0;
    top: 0;
}

.wraper-body-report-table-section table tbody tr:nth-child(odd) td:first-child {
    background: #F3F3F3 0% 0% no-repeat padding-box;
}

.wraper-body-report-table-section table thead tr th:first-child,
.wraper-body-report-table-section table tbody tr:nth-child(even) td:first-child,
.wraper-body-report-table-section table tbody tr:nth-child(even) {
    background: #FFFFFF 0% 0% no-repeat padding-box;
}

.wraper-pagination-item-section{
    column-gap: 10px;
}
.wraper-pagination-item-section .pagination-rang-item-group-section select{
    height: 40px !important;
    padding: 0.675rem 2.75rem 0.5rem 0.5rem !important;
    background-color: var(--neutral-color1) !important;
}


/* .wraper-body-report-table-section {
    overflow-x: scroll;
    min-height: 50vh;
    margin-bottom: 30px;
    overflow-y: hidden;
    border: 1px solid var(--neutral-color4);
    border-radius: 6px 6px 0px 0px;
} */

/* .wraper-body-report-table-section table{ */
/* overflow-y: scroll; */
/* overflow: scroll; */
/* height: 50vh; */
/* border-spacing: 0px; */
/* } */

/* .wraper-body-report-table-section table thead,
.wraper-body-report-table-section table tbody{
    border: 1px solid black;
} */
/* .wraper-body-report-table-section table thead{
    border-bottom: 1px solid var(--neutral-color4);
}

.wraper-body-report-table-section table tr{
    min-height: 30px;
}

.wraper-body-report-table-section table thead tr{
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px 6px 0px 0px;
    position: sticky;
    top: 0;
}
.wraper-body-report-table-section table tr th,
.wraper-body-report-table-section table tr td{
    min-width: 190px;
    padding: 5px;
}
.wraper-body-report-table-section table tr th:nth-child(1),
.wraper-body-report-table-section table tr td:nth-child(1){
    min-width: 60px;
}
.wraper-body-report-table-section table tr th{
    text-align: left;
    font: normal normal bold 14px/19px Lato;
    letter-spacing: 0.14px;
    color: #666666;
} */

/* ----- Scroll Bar ------ */
.wraper-body-report-table-section::-webkit-scrollbar {
    display: block !important;
    width: var(--body-scrollbar-width);
    height: 5px;
}

.wraper-body-report-table-section::-webkit-scrollbar-track {
    background-color: #fff9f900;
}

.wraper-body-report-table-section::-webkit-scrollbar-track-piece {
    background-color: #00000000;
}

.wraper-body-report-table-section::-webkit-scrollbar-thumb {
    background-color: #86868640;
    border: 1px solid #1a191940;
    border-radius: 24px;
}

#viewWorkOrderReportAdvanceSearch .mobal-body-section-group:nth-child(2){
    display: grid;
    row-gap: 10px;
}
/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    .view-workorder-report-header-search-group-row-section,
    .view-workorder-report-search-group-section .view-workorder-report-serch-item-section:first-child{
        grid-template-columns: 1fr !important;
    }
    
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/ViewWorkOrderReportPage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,qBAAqB;AACzB;AACA;;IAEI,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;AACxC;;;;AAIA,sCAAsC;AACtC;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,iCAAiC;IACjC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,MAAM;IACN,+CAA+C;IAC/C,iCAAiC;IACjC,UAAU;AACd;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,eAAe;IAEf,gBAAgB;IAChB,OAAO;IACP,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,8BAA8B;IAC9B,oCAAoC;IACpC,OAAO;IACP,MAAM;AACV;;AAEA;IACI,+CAA+C;AACnD;;AAEA;;;IAGI,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,kDAAkD;IAClD,kDAAkD;AACtD;;;AAGA;;;;;;;GAOG;;AAEH,6CAA6C;AAC7C,wBAAwB;AACxB,sBAAsB;AACtB,kBAAkB;AAClB,yBAAyB;AACzB,MAAM;;AAEN;;;GAGG;AACH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6BG;;AAEH,4BAA4B;AAC5B;IACI,yBAAyB;IACzB,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;AACA,wCAAwC;AACxC;IACI;;QAEI,qCAAqC;IACzC;;AAEJ","sourcesContent":[".view-workorder-report-search-group-section {\r\n    width: 100%;\r\n}\r\n\r\n.view-workorder-report-header-search-group-row-section {\r\n    grid-template-columns: 3.2fr 0.8fr !important;\r\n}\r\n\r\n.view-workorder-report-serch-item-section .react-date-picker__calendar{\r\n    z-index: 4 !important;\r\n}\r\n.view-workorder-report-search-group-section .view-workorder-report-serch-item-section:first-child,\r\n.view-workorder-report-search-group-section .view-workorder-report-serch-item-section:nth-child(2) {\r\n    display: grid;\r\n    column-gap: 10px;\r\n    grid-template-columns: 1fr 1fr;\r\n    row-gap: 10px;\r\n}\r\n\r\n#viewWorkOrderReportAdvanceSearch .modal-body {\r\n    overflow-y: initial;\r\n}\r\n\r\n#viewWorkOrderReportAdvanceSearch .modal-dialog .modal-body .wrapper-modal-body .mobal-body-section-group:nth-child(3) {\r\n    grid-template-columns: 1fr;\r\n}\r\n\r\n#viewWorkOrderReportAdvanceSearch .wrapper-modal-body .react-date-picker__calendar.react-date-picker__calendar--open {\r\n    inset: 100% 0px auto auto !important;\r\n}\r\n\r\n\r\n\r\n/* ------- View Report Table ------- */\r\n.wraper-body-report-table-section {\r\n    width: 100%;\r\n    height: 50vh;\r\n    overflow: scroll;\r\n    /* border: 1px solid; */\r\n    box-shadow: 0px 0px 6px #00000029;\r\n    border-radius: 6px;\r\n    display: block;\r\n}\r\n\r\n.wraper-body-report-table-section table thead {\r\n    border-bottom: 1px solid;\r\n    position: sticky;\r\n    top: 0;\r\n    background: #FFFFFF 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 0px 6px #00000029;\r\n    z-index: 2;\r\n}\r\n\r\n.wraper-body-report-table-section table tr th,\r\n.wraper-body-report-table-section table tr td {\r\n    min-width: 190px;\r\n    padding: 6px;\r\n}\r\n\r\n.wraper-body-report-table-section table thead tr th:first-child,\r\n.wraper-body-report-table-section table tbody tr td:first-child {\r\n    min-width: 90px;\r\n    position: -webkit-sticky;\r\n    position: sticky;\r\n    left: 0;\r\n    z-index: 1;\r\n}\r\n\r\n.wraper-body-report-table-section table thead tr th:first-child::after,\r\n.wraper-body-report-table-section table tbody tr td:first-child::after{\r\n    content: \"\";\r\n    height: 100%;\r\n    width: 100%;\r\n    position: absolute;\r\n    border-right: 1px solid F3F3F3;\r\n    box-shadow: 4px 0 5px -2px #00000029;\r\n    left: 0;\r\n    top: 0;\r\n}\r\n\r\n.wraper-body-report-table-section table tbody tr:nth-child(odd) td:first-child {\r\n    background: #F3F3F3 0% 0% no-repeat padding-box;\r\n}\r\n\r\n.wraper-body-report-table-section table thead tr th:first-child,\r\n.wraper-body-report-table-section table tbody tr:nth-child(even) td:first-child,\r\n.wraper-body-report-table-section table tbody tr:nth-child(even) {\r\n    background: #FFFFFF 0% 0% no-repeat padding-box;\r\n}\r\n\r\n.wraper-pagination-item-section{\r\n    column-gap: 10px;\r\n}\r\n.wraper-pagination-item-section .pagination-rang-item-group-section select{\r\n    height: 40px !important;\r\n    padding: 0.675rem 2.75rem 0.5rem 0.5rem !important;\r\n    background-color: var(--neutral-color1) !important;\r\n}\r\n\r\n\r\n/* .wraper-body-report-table-section {\r\n    overflow-x: scroll;\r\n    min-height: 50vh;\r\n    margin-bottom: 30px;\r\n    overflow-y: hidden;\r\n    border: 1px solid var(--neutral-color4);\r\n    border-radius: 6px 6px 0px 0px;\r\n} */\r\n\r\n/* .wraper-body-report-table-section table{ */\r\n/* overflow-y: scroll; */\r\n/* overflow: scroll; */\r\n/* height: 50vh; */\r\n/* border-spacing: 0px; */\r\n/* } */\r\n\r\n/* .wraper-body-report-table-section table thead,\r\n.wraper-body-report-table-section table tbody{\r\n    border: 1px solid black;\r\n} */\r\n/* .wraper-body-report-table-section table thead{\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n}\r\n\r\n.wraper-body-report-table-section table tr{\r\n    min-height: 30px;\r\n}\r\n\r\n.wraper-body-report-table-section table thead tr{\r\n    background: #FFFFFF 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 0px 6px #00000029;\r\n    border-radius: 6px 6px 0px 0px;\r\n    position: sticky;\r\n    top: 0;\r\n}\r\n.wraper-body-report-table-section table tr th,\r\n.wraper-body-report-table-section table tr td{\r\n    min-width: 190px;\r\n    padding: 5px;\r\n}\r\n.wraper-body-report-table-section table tr th:nth-child(1),\r\n.wraper-body-report-table-section table tr td:nth-child(1){\r\n    min-width: 60px;\r\n}\r\n.wraper-body-report-table-section table tr th{\r\n    text-align: left;\r\n    font: normal normal bold 14px/19px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: #666666;\r\n} */\r\n\r\n/* ----- Scroll Bar ------ */\r\n.wraper-body-report-table-section::-webkit-scrollbar {\r\n    display: block !important;\r\n    width: var(--body-scrollbar-width);\r\n    height: 5px;\r\n}\r\n\r\n.wraper-body-report-table-section::-webkit-scrollbar-track {\r\n    background-color: #fff9f900;\r\n}\r\n\r\n.wraper-body-report-table-section::-webkit-scrollbar-track-piece {\r\n    background-color: #00000000;\r\n}\r\n\r\n.wraper-body-report-table-section::-webkit-scrollbar-thumb {\r\n    background-color: #86868640;\r\n    border: 1px solid #1a191940;\r\n    border-radius: 24px;\r\n}\r\n\r\n#viewWorkOrderReportAdvanceSearch .mobal-body-section-group:nth-child(2){\r\n    display: grid;\r\n    row-gap: 10px;\r\n}\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    .view-workorder-report-header-search-group-row-section,\r\n    .view-workorder-report-search-group-section .view-workorder-report-serch-item-section:first-child{\r\n        grid-template-columns: 1fr !important;\r\n    }\r\n    \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
